import { client } from '@/common-utils/libraries/axios/axios';
import USERS from '../apiUrls';

const mutationCreateUser = (onSuccess, onError) => {
    return {
        mutationFn: (usersList) => {
            return client.post(USERS.COLLECTION.url, usersList);
        },
        // onError: (error, variables, context)
        onError: (error) => {
            onError(error);
        },
        // onSuccess: (data, variables, context)
        onSuccess: () => {
            onSuccess();
        },
        // onSettled: (data, error, variables, context)
        onSettled: () => {
            // Error or success... doesn't matter!
        }
    };
};

export default mutationCreateUser;